import { fromEvent } from "rxjs";
import { distinctUntilChanged, pluck } from "rxjs/operators";
import { FormFieldComponent } from "../formFieldComponent";
import { Form } from "../form";
import { show } from "../../utils";
import { IMessagingService } from "../../services";

class TextareaComponent extends FormFieldComponent {

    private textAreaEl: HTMLTextAreaElement;
    private wordCountEl: HTMLSpanElement;
    private oldValue: string;
    private maxWords: number = 0;

    constructor(protected fieldEl: HTMLElement, messagingService: IMessagingService, protected form: Form) {
        super(fieldEl, messagingService, form);


        this.textAreaEl = fieldEl.querySelector<HTMLTextAreaElement>(".js-textarea");
        this.wordCountEl = fieldEl.querySelector<HTMLSpanElement>(".js-wordcount");
        
        const maxWordsValue = fieldEl.dataset["maxWordCount"];

        if (maxWordsValue)
        {
            this.maxWords = parseInt(maxWordsValue);
            show(this.wordCountEl);

            // listen for user input and recalculate word count
            const onTextareaKeyUp$ = fromEvent(this.textAreaEl, "keyup").pipe(
                pluck("target", "value"),
                distinctUntilChanged()
            );
            onTextareaKeyUp$.subscribe((value: string) => {
                this.applyMaxWordLimit(value);
            });
        }

        // listen for the field changing
        const onTextareaChanged$ = fromEvent(this.textAreaEl, "change").pipe(
            pluck("target", "value"),
            distinctUntilChanged()
        );

        onTextareaChanged$.subscribe((value: string) => {
            this.setResponseValue(value);
        });
    }

    private applyMaxWordLimit(value: string) {
        value = value.trim();

        let wordCount = value === "" ? 0 : value.trim().split(/\s+/).length;

        if (wordCount > this.maxWords) {
            this.textAreaEl.value = this.oldValue.trim();
        }
        else {
            this.wordCountEl.innerText = `${this.maxWords - wordCount} ${wordCount === this.maxWords - 1 ? "word" : "words"} left`;
            this.oldValue = value.trim();
        }
    }

    // update the value of this field in the DOM.
    protected setDisplayValue(value: any) {
        if(value) {
            this.textAreaEl.value = value;
        }
    }

    public setFocus() {
        this.textAreaEl.focus();
    }

};

export { TextareaComponent };